import { domain } from 'modules/data';
import { useCallback } from 'react';

import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';

export const useCustomScheduleTypeSelector = (ruleIndex: number) => {
    const { schedule, updateRuleConfig } = useReportSchedulerContext();

    const ruleConfig = schedule.rules[ruleIndex].configuration;
    const value = ruleConfig.customSchedulePeriodicity;

    const handleChange = useCallback(
        (newValue: domain.CustomScheduleType) => {
            updateRuleConfig(ruleIndex, {
                customSchedulePeriodicity: newValue,
            });
        },
        [ruleIndex, updateRuleConfig]
    );

    return {
        value,
        handleChange,
    };
};
